import {
	LAST_FIRST_REGEX,
	FIRST_LAST_REGEX,
	EMAIL_REGEX,
	PHONE_REGEX,
	LABELED_PHONE_REGEX
} from './regex'

export const COLUMN = [
    {
        key: 'ignore',
        regex: [
            /^Email\,\s*MyChart$/,
            /^\$\d+\.\d+$/i
        ]
    },
    // {
    //     key: 'code',
    //     exclusive: false,
    //     regex: [
    //         CODE_REGEX
    //     ]
    // },
    {
        key: 'email',
        regex: [
            EMAIL_REGEX
        ],
        email: true
    },
    {
        key: 'event',
        regex: [],
        event: true,
        exclusive: false
    },
    {
        key: 'doctor',
        regex: [
            /^\w+\,\s*\w+(\s+\w+)?\s*\[\d+\]/i
        ],
        doctor: true
    },
    // {
    //     key: 'consult',
    //     regex: [
    //         /CONSULT/i,
    //         /FOLLOW\s*UP/i,
    //         /F\s*\/\s*U/i
    //     ]
    // },
    {
        key: 'name',
        regex: [
            LAST_FIRST_REGEX,
            FIRST_LAST_REGEX
        ]
    },
    {
        key: 'phone',
        regex: [
            PHONE_REGEX,
            LABELED_PHONE_REGEX
        ]
    },
    {
        key: 'date',
        regex: [
            /^\d+\s*(\/|\-)\s*\d+\s*(\/|\-)\s*(202[0-9]|2[0-9])?\s*((Mon|Tue|Tues|Wed|Wednes|Thu|Thurs|Fri|Sat|Satur|Sun)(day)?)?$/i,
        ]
    },
    {
        key: 'birthdate',
        regex: [
            /^\d+\s*(\/|\-)\s*\d+\s*(\/|\-)\s*\d+(\s+(Mon|Tue|Tues|Wed|Wednes|Thu|Thurs|Fri|Sat|Satur|Sun)(day)?)?$/i
        ]
    },
    {
        key: 'time',
        regex: [
            /^\s*\d+\:\d+(\:\d+)?\s*(AM|PM|a|p)\s*$/        // Matches HH:MM
        ]
    }
]

export const NAME_COLUMN = COLUMN.find((c) => (c.key == 'name'))
export const EMAIL_COLUMN = COLUMN.find((c) => (c.key == 'email'))
export const PHONE_COLUMN = COLUMN.find((c) => (c.key == 'phone'))
